
import AuthImage from '@/components/image/AuthImage.vue'
import JigTextField from '@/components/input/JigTextField.vue'
import JigTooltip from '@/components/input/JigTooltip.vue'
import LabelWithHint from '@/components/input/LabelWithHint.vue'
import MoreModelActions from '@/components/input/MoreModelActions.vue'
import GenerateJigModal from '@/components/modals/GenerateJigModal.vue'
import LibraryCategoriesModal from '@/components/modals/LibraryCategoriesModal.vue'
import PromptYesNo from '@/components/modals/PromptYesNo.vue'
import UploadLibraryThumbnailDialog from '@/components/modals/UploadLibraryThumbnailDialog.vue'
import FilePreview from '@/components/tenant/FilePreview.vue'
import { TeamLibraryConst } from '@/constants/teamlibrary'
import FiltersMixin from '@/mixin/Filters'
import LibraryMixin from '@/mixin/Library'
import { LibraryObjectVisibility, LibraryVisibilities } from '@/modules/library/constants'
import helpers from '@/modules/library/helpers'
import { LibraryVisibility } from '@/modules/library/types'
import { Permissions } from '@/security/permissions'
import { PermissionActions } from '@/store/constants'
import { Tenant } from '@/store/modules/app/types'
import {
  ContextProcessingStatusResponse,
  LibraryCategoriesUsage,
  LibraryCategorySelectItem,
  LibraryEntry,
  LibraryItem,
  LibraryReferenceAsset,
  LoadContextProcessingStatusResult,
} from '@/store/modules/teamlibrary/types'
import { Namespace, UploadThumbnailRequest } from '@/store/types'
import { CategoryHelpers } from '@/utils/category-helpers'
import { Filters } from '@/utils/filters'
import { ValidationRules } from '@/utils/input-validation'
import { TenantHelpers } from '@/utils/tenant-helpers'
import IconBin from '@svg/IconBin.svg'
import IconClose from '@svg/IconClose.svg'
import IconSpinner from '@svg/IconSpinner.svg'
import IconRotate from '@svg/Icon_Rotate.svg'
import IconView from '@svg/Icon_View.svg'
import IconsUploadFile from '@svg/IconsUploadFile.svg'
import { mixins } from 'vue-class-component'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation, State } from 'vuex-class'

interface ReferenceContextStatusState {
  contextId: number | null
  statusCopy: string
  statusClass: string
  canRefresh: boolean
  isRefreshing: boolean
  lastRefreshAt: number
  requestToken: number
}

@Component({
  components: {
    AuthImage,
    FilePreview,
    GenerateJigModal,
    IconBin,
    IconClose,
    IconRotate,
    IconSpinner,
    IconView,
    IconsUploadFile,
    JigTextField,
    JigTooltip,
    LabelWithHint,
    LibraryCategoriesModal,
    MoreModelActions,
    PromptYesNo,
    UploadLibraryThumbnailDialog,
  },
})
export default class LibraryEntryVue extends mixins(FiltersMixin, LibraryMixin) {
  @State('libraryEntry', { namespace: Namespace.TeamLibrary })
  public libraryEntry!: LibraryEntry
  @State('libraryCategoriesUsage', { namespace: Namespace.TeamLibrary })
  public libraryCategoriesUsage!: LibraryCategoriesUsage
  @State('libraryReferenceAssets', { namespace: Namespace.TeamLibrary })
  public libraryReferenceAssets!: LibraryReferenceAsset[]
  @State('myTenantIndex', { namespace: Namespace.App }) public myTenantIndex!: number
  @State('myTenants', { namespace: Namespace.App }) public myTenants!: Tenant[]

  @Getter('libraryModelUID', { namespace: Namespace.TeamLibrary })
  public libraryModelUID!: number
  @Getter('isPreparingApp', { namespace: Namespace.Utils })
  public isPreparingApp!: boolean

  @Getter('isJigSparkOptIn', { namespace: Namespace.App })
  public isJigSparkOptIn!: boolean
  @Getter('libraryPublicCategoriesIDs', { namespace: Namespace.TeamLibrary })
  public libraryPublicCategoriesIDs!: number[]

  @Action('loadLibraryEntry', { namespace: Namespace.TeamLibrary })
  public loadLibraryEntry: any
  @Action('deleteLibraryEntryById', { namespace: Namespace.TeamLibrary })
  public deleteLibraryEntryById: any
  @Action('updateLibraryEntry', { namespace: Namespace.TeamLibrary })
  public updateLibraryEntry: any
  @Action('uploadLibraryEntryThumbnail', { namespace: Namespace.TeamLibrary })
  public uploadLibraryEntryThumbnail: any
  @Action('loadLibraryCategoryStates', { namespace: Namespace.TeamLibrary })
  public loadLibraryCategoryStates: any
  @Action('presignedFile', { namespace: Namespace.TeamLibrary })
  public presignedFile: any
  @Action('uploadReferenceFile', { namespace: Namespace.TeamLibrary })
  public uploadReferenceFile: any
  @Action('loadLibraryCategoriesUsage', { namespace: Namespace.TeamLibrary })
  public loadLibraryCategoriesUsage: any
  @Action('loadLibraryReferenceAssets', { namespace: Namespace.TeamLibrary })
  public loadLibraryReferenceAssets: any
  @Action('loadReferenceContextProcessingStatus', { namespace: Namespace.TeamLibrary })
  public loadReferenceContextProcessingStatus: any
  @Action('completeLibraryReferenceFileUpload', { namespace: Namespace.TeamLibrary })
  public completeLibraryReferenceFileUpload: any
  @Action('deleteLibraryReferenceAssetById', { namespace: Namespace.TeamLibrary })
  public deleteLibraryReferenceAssetById: any
  @Mutation('removeLibraryReferenceAssetByGuid', { namespace: Namespace.TeamLibrary })
  public removeLibraryReferenceAssetByGuid: any
  @Mutation('updateReferenceAssetContextStatus', { namespace: Namespace.TeamLibrary })
  public updateReferenceAssetContextStatus: any

  declare $refs: Vue['$refs'] & {
    deleteAssetPromptYesNo: PromptYesNo
    deleteEntryPromptYesNo: PromptYesNo
    publishEntryPromptYesNo: PromptYesNo
    refPDFFileInput: any
  }

  private isLoadingEntryData: boolean = false
  private hasInitiallyLoaded: boolean = false
  private visibilityPublic: string = LibraryObjectVisibility.Public
  private selectedEntry: any = { Id: '', DisplayName: '', Visibility: '' }
  private formIsValid: boolean = false
  private nameRules!: any
  private objectTagsRules!: any
  private urlRules!: any
  private uploadRules!: any

  private needPublishCheck: boolean = false
  private visibilityAlreadyPublic: boolean = false
  private readonly stateIdHidden = TeamLibraryConst.LibraryCategoriesStateId.Hidden
  private readonly stateIdDeprecated = TeamLibraryConst.LibraryCategoriesStateId.Deprecated
  private objectTags: string = ''
  private selectedCategory: number | null = null
  private referencePDFFile: File | null = null
  private refPDFFileName: string = ''
  private pdfFileSizeError: string = ''
  private readonly maxPDFFileSize = TeamLibraryConst.ReferenceFileMaxSizeBytes
  private referencePDFToDelete: LibraryReferenceAsset | null = null
  private referenceContextStatuses: Record<string, ReferenceContextStatusState> = {}
  private readonly referenceContextRefreshThrottleMs: number = 1500
  private previewDialogVisible: boolean = false
  private previewFilename: string = 'Document preview'
  private previewReferenceId: number = 0
  private previewContentType: string = ''
  private previewTenantId: number = TenantHelpers.InvalidTenantID
  private previewOpeningAssets: Record<string, boolean> = {}

  private showUploadModel: boolean = false
  private showCategoriesModel: boolean = false
  private isUploadingThumbnail: boolean = false
  private isSubmittingPDF: boolean = false
  private isCategoriesUsageLoading: boolean = false

  private isJigSpaceStaff: boolean = false
  private canEdit: boolean = false
  private canDelete: boolean = false
  private canGenerateJig: boolean = false

  private tagRules: any = {
    extra: [(v: any) => (v && !v.includes(',')) || 'Comma is not allowed'],
  }

  private readonlyMetadataBaseList: Partial<Record<keyof LibraryEntry, any>> = {
    Id: { label: 'Id', type: 'number' },
    UID: { label: 'UID', type: 'number' },
    Author: { label: 'Author', type: 'string' },
    DateCreated: { label: 'Created', type: 'datetime_string' },
    DateUpdated: { label: 'Last updated', type: 'datetime_string' },
    Version: { label: 'Version', type: 'number' },
  }
  private readonlyMetadataItemList: Partial<Record<keyof LibraryItem, any>> = {
    TriangleCount: { label: 'Triangles count', type: 'formated_number' },
    ObjectCount: { label: 'Sub-objects count', type: 'formated_number' },
    OriginalFileSizeInBytes: { label: 'Original size', type: 'filesize' },
    FileName: { label: 'Output file name', type: 'string' },
  }

  @Watch('initializing')
  private async onInitializingChanged(value: boolean, oldValue: boolean) {
    if (!value) {
      if (this.hasInitiallyLoaded) {
        // Tenant switch — redirect to library since this entry may not exist on the new tenant
        this.$router.push('/library')
        return
      }
      this.checkPermissions()
      await this.prepareEntryData()
      this.hasInitiallyLoaded = true
    }
  }

  protected async created() {
    this.nameRules = ValidationRules.RequiredName
    this.objectTagsRules = ValidationRules.OptionalCommaSeparatedStrings
    this.urlRules = ValidationRules.OptionalUrl
    this.uploadRules = ValidationRules.PngImageUpload

    if (this.initializing) return

    this.checkPermissions()
    await this.prepareEntryData()
    this.hasInitiallyLoaded = true
  }

  protected async mounted() {
    if (this.initializing) return
  }

  // Override the hook method
  protected onAfterTenantChanged(): void {
    this.checkPermissions()
  }

  private get hasReachedMaxReferencePDFs(): boolean {
    return this.libraryReferenceAssets.length >= TeamLibraryConst.LibraryEntryMaxReferencePDFs
  }

  private get maxReferenceFileMsg(): string {
    return `Maximum ${TeamLibraryConst.LibraryEntryMaxReferencePDFs} reference files allowed. Please delete existing files to add new ones.`
  }

  private get allowedReferenceFileType(): string {
    return TeamLibraryConst.LibraryModalAllowedReferenceType.join(',')
  }

  private get validLibraryCategories(): LibraryCategorySelectItem[] {
    return CategoryHelpers.buildCategorySelectItems({
      tenantCategories: this.libraryCategories,
      publicCategories: this.libraryPublicCategories,
      includePublic: this.isJigSpaceStaff,
      hiddenStateId: this.stateIdHidden,
      deprecatedStateId: this.stateIdDeprecated,
    })
  }

  private get libraryVisibilities(): LibraryVisibility[] {
    return LibraryVisibilities
  }

  private get dimensionInfo(): string {
    return `${TeamLibraryConst.ModelThumbnailDimension.width} x ${TeamLibraryConst.ModelThumbnailDimension.height}`
  }

  private get isPreparingDetails(): boolean {
    return this.isPreparingApp || this.isLoadingEntryData
  }

  private get isFormDisabled(): boolean {
    return this.isPreparingDetails || this.isSubmittingPDF
  }

  private get thumbnailSrc(): string {
    return this.libraryEntry.ThumbnailUrl || ''
  }

  private get metadataBaseList(): Partial<Record<keyof LibraryEntry, any>> {
    const fields: Partial<Record<keyof LibraryEntry, any>> = {}

    for (const metaKey in this.readonlyMetadataBaseList) {
      const typedKey = metaKey as keyof LibraryEntry
      const { label, type } = this.readonlyMetadataBaseList[typedKey]

      if (this.libraryEntry[typedKey] == null) {
        fields[typedKey] = {
          label,
          value: 'N/A',
        }
        continue
      }

      const fieldDetails: Record<string, any> = {
        label,
        value: this.libraryEntry[typedKey],
      }

      switch (type) {
        case 'number':
          fieldDetails.value = Number(this.libraryEntry[typedKey])
          if (isNaN(fieldDetails.value)) fieldDetails.value = 'N/A'
          break
        case 'datetime_string':
          fieldDetails.value = Filters.formatDate(this.libraryEntry[typedKey] as string)
          break
      }

      fields[typedKey] = fieldDetails
    }

    return fields
  }

  private get metadataItemList(): Partial<Record<keyof LibraryItem, any>> {
    const fields: Partial<Record<keyof LibraryItem, any>> = {}

    for (const metaKey in this.readonlyMetadataItemList) {
      const typedKey = metaKey as keyof LibraryItem
      const { label, type, key } = this.readonlyMetadataItemList[typedKey]

      if (this.libraryEntry.Item[typedKey] == null) {
        fields[typedKey] = {
          label,
          value: 'N/A',
        }
        continue
      }

      const fieldDetails: Record<string, any> = {
        label,
        value: this.libraryEntry.Item[typedKey],
      }

      switch (type) {
        case 'number':
          fieldDetails.value = Number(this.libraryEntry.Item[typedKey])
          if (isNaN(fieldDetails.value)) fieldDetails.value = 'N/A'
          break
        case 'formated_number':
          fieldDetails.value = Number(this.libraryEntry.Item[typedKey])
          if (isNaN(fieldDetails.value)) {
            fieldDetails.value = 'N/A'
          } else {
            fieldDetails.value = fieldDetails.value.toLocaleString('en-US')
          }
          break
        case 'array_length':
          fieldDetails.value = this.libraryEntry.Item[typedKey][key].length
          break
        case 'filesize':
          fieldDetails.value = helpers.formatFileSize(Number(this.libraryEntry.Item[typedKey]))
          break
      }

      fields[typedKey] = fieldDetails
    }

    return fields
  }

  private get hasSelectedPDF(): boolean {
    return this.referencePDFFile != null
  }

  private get toDeleteFileDetails(): string {
    return this.referencePDFToDelete ? `${this.referencePDFToDelete.originalFilename} (GUID: ${this.referencePDFToDelete.assetGuid})` : ''
  }

  private previewAssetKey(asset: LibraryReferenceAsset): string {
    return asset.assetGuid || `${asset.referenceId}`
  }

  private isPreviewOpening(asset: LibraryReferenceAsset): boolean {
    return !!this.previewOpeningAssets[this.previewAssetKey(asset)]
  }

  private getReferenceContextStatus(asset: LibraryReferenceAsset): ReferenceContextStatusState {
    const existingStatus = this.referenceContextStatuses[asset.assetGuid]
    if (existingStatus) {
      return existingStatus
    }

    return this.buildReferenceContextStatusState(null, 'Context status: not available', 'disabled', false)
  }

  private shouldShowReferenceContextRefresh(asset: LibraryReferenceAsset): boolean {
    return this.getReferenceContextStatus(asset).canRefresh
  }

  private isReferenceContextRefreshDisabled(asset: LibraryReferenceAsset): boolean {
    return this.isSubmittingPDF || this.getReferenceContextStatus(asset).isRefreshing
  }

  private buildReferenceContextStatusState(
    contextId: number | null,
    statusCopy: string,
    statusClass: string,
    canRefresh: boolean,
    isRefreshing: boolean = false,
    lastRefreshAt: number = 0,
    requestToken: number = 0
  ): ReferenceContextStatusState {
    return {
      contextId,
      statusCopy,
      statusClass,
      canRefresh,
      isRefreshing,
      lastRefreshAt,
      requestToken,
    }
  }

  private updateReferenceContextStatus(assetGuid: string, nextStatus: ReferenceContextStatusState) {
    this.$set(this.referenceContextStatuses, assetGuid, nextStatus)
  }

  private clearReferenceContextStatus(assetGuid: string) {
    if (this.referenceContextStatuses[assetGuid] != null) {
      this.$delete(this.referenceContextStatuses, assetGuid)
    }
  }

  private clearRemovedReferenceContextStatuses() {
    const activeAssetGuids = this.libraryReferenceAssets.map((asset: LibraryReferenceAsset) => asset.assetGuid)
    for (const assetGuid in this.referenceContextStatuses) {
      if (!activeAssetGuids.includes(assetGuid)) {
        this.clearReferenceContextStatus(assetGuid)
      }
    }
  }

  private initializeReferenceContextStatuses() {
    this.clearRemovedReferenceContextStatuses()

    for (const asset of this.libraryReferenceAssets) {
      if (!asset.ctxUrl) {
        this.updateReferenceContextStatus(
          asset.assetGuid,
          this.buildReferenceContextStatusState(null, 'Context status: not available', 'disabled', false)
        )
        continue
      }

      const contextId = this.extractContextIdFromCtxUrl(asset.ctxUrl)
      if (contextId == null) {
        this.updateReferenceContextStatus(asset.assetGuid, this.buildFailedReferenceContextStatus(null))
        continue
      }

      const existingStatus = this.referenceContextStatuses[asset.assetGuid]
      const statusCopy = existingStatus ? existingStatus.statusCopy : 'Context status: pending'
      this.updateReferenceContextStatus(asset.assetGuid, this.buildReferenceContextStatusState(contextId, statusCopy, 'in-progress', true))
    }
  }

  private loadReferenceContextStatuses() {
    return Promise.all(this.libraryReferenceAssets.map((asset: LibraryReferenceAsset) => this.refreshReferenceContextStatus(asset, true)))
  }

  private isTerminalReferenceContextLookupFailure(result: LoadContextProcessingStatusResult): boolean {
    return !result.success && result.statusCode === 404
  }

  private buildRetryableReferenceContextStatus(
    contextId: number,
    lastRefreshAt: number,
    requestToken: number
  ): ReferenceContextStatusState {
    return this.buildReferenceContextStatusState(
      contextId,
      'Context status: unavailable',
      'errored',
      true,
      false,
      lastRefreshAt,
      requestToken
    )
  }

  private async refreshReferenceContextStatus(asset: LibraryReferenceAsset, force: boolean = false) {
    if (!asset || !asset.assetGuid) {
      return
    }

    if (!asset.ctxUrl) {
      this.updateReferenceContextStatus(
        asset.assetGuid,
        this.buildReferenceContextStatusState(null, 'Context status: not available', 'disabled', false)
      )
      return
    }

    const contextId = this.extractContextIdFromCtxUrl(asset.ctxUrl)
    if (contextId == null) {
      this.updateReferenceContextStatus(asset.assetGuid, this.buildFailedReferenceContextStatus(null))
      return
    }

    const now = Date.now()
    const existingStatus = this.referenceContextStatuses[asset.assetGuid]
    if (existingStatus && existingStatus.isRefreshing) {
      return
    }

    if (!force && existingStatus && existingStatus.lastRefreshAt > 0) {
      const elapsedSinceLastRefresh = now - existingStatus.lastRefreshAt
      if (elapsedSinceLastRefresh < this.referenceContextRefreshThrottleMs) {
        return
      }
    }

    const requestToken = existingStatus ? existingStatus.requestToken + 1 : 1
    const pendingStatusCopy = existingStatus && existingStatus.statusCopy ? existingStatus.statusCopy : 'Context status: pending'

    this.updateReferenceContextStatus(
      asset.assetGuid,
      this.buildReferenceContextStatusState(contextId, pendingStatusCopy, 'in-progress', true, true, now, requestToken)
    )

    const result: LoadContextProcessingStatusResult = await this.loadReferenceContextProcessingStatus(contextId)
    const latestStatus = this.referenceContextStatuses[asset.assetGuid]

    if (!this.hasReferenceAsset(asset.assetGuid) || !latestStatus || latestStatus.requestToken !== requestToken) {
      return
    }

    if (!result.success) {
      if (this.isTerminalReferenceContextLookupFailure(result)) {
        this.updateReferenceContextStatus(asset.assetGuid, this.buildFailedReferenceContextStatus(contextId, false, now, requestToken))
        this.updateReferenceAssetContextStatus({ assetGuid: asset.assetGuid, contextStatus: 'failed' })
        return
      }

      this.updateReferenceContextStatus(asset.assetGuid, this.buildRetryableReferenceContextStatus(contextId, now, requestToken))
      return
    }

    const resolvedStatus = result.data && result.data.status ? String(result.data.status).trim() : 'failed'
    this.updateReferenceAssetContextStatus({ assetGuid: asset.assetGuid, contextStatus: resolvedStatus })
    this.updateReferenceContextStatus(asset.assetGuid, this.mapContextProcessingStatus(contextId, result.data, now, requestToken))
  }

  private hasReferenceAsset(assetGuid: string): boolean {
    return this.libraryReferenceAssets.some((asset: LibraryReferenceAsset) => asset.assetGuid === assetGuid)
  }

  private extractContextIdFromCtxUrl(ctxUrl: string): number | null {
    if (!ctxUrl) {
      return null
    }

    const match = ctxUrl.match(/\/context\/(\d+)(?:\/|$|\?)/)
    if (!match || !match[1]) {
      return null
    }

    const contextId = parseInt(match[1], 10)
    return isNaN(contextId) ? null : contextId
  }

  private mapContextProcessingStatus(
    contextId: number,
    response: ContextProcessingStatusResponse | undefined,
    lastRefreshAt: number,
    requestToken: number
  ): ReferenceContextStatusState {
    const statusValue = response && response.status ? String(response.status).trim() : ''
    const normalizedStatus = statusValue.length > 0 ? statusValue : 'failed'

    switch (normalizedStatus) {
      case 'completed':
        return this.buildReferenceContextStatusState(
          contextId,
          `Context status: ${normalizedStatus}`,
          'successful',
          false,
          false,
          lastRefreshAt,
          requestToken
        )
      case 'pending':
      case 'processing':
        return this.buildReferenceContextStatusState(
          contextId,
          `Context status: ${normalizedStatus}`,
          'in-progress',
          true,
          false,
          lastRefreshAt,
          requestToken
        )
      case 'failed':
      case 'partially_failed':
        return this.buildReferenceContextStatusState(
          contextId,
          `Context status: ${normalizedStatus}`,
          'errored',
          false,
          false,
          lastRefreshAt,
          requestToken
        )
      default:
        return this.buildFailedReferenceContextStatus(contextId, false, lastRefreshAt, requestToken)
    }
  }

  private buildFailedReferenceContextStatus(
    contextId: number | null,
    isRefreshing: boolean = false,
    lastRefreshAt: number = 0,
    requestToken: number = 0
  ): ReferenceContextStatusState {
    return this.buildReferenceContextStatusState(
      contextId,
      'Context status: failed',
      'errored',
      false,
      isRefreshing,
      lastRefreshAt,
      requestToken
    )
  }

  private async prepareEntryData() {
    this.isLoadingEntryData = true
    const id = this.$route.params.id.toString()

    // Load tenant categories and optionally public categories (if JigSpace Staff)
    const promiseTenantCategories = this.loadLibraryCategories(this.myTenantID)
    const promisePublicCategories = this.isJigSpaceStaff ? this.loadLibraryCategories() : Promise.resolve(true)
    const promiseEntry = this.loadLibraryEntry({ Id: id })

    await this.loadLibraryCategoryStates()
    const results = await Promise.all([promiseTenantCategories, promisePublicCategories, promiseEntry])

    if (!results.every((result) => result)) {
      this.isLoadingEntryData = false
      return
    }

    await this.awaitLibraryEntryLoad(promiseEntry)
    this.isLoadingEntryData = false
  }

  private async deleteEntryById() {
    const deletionResult = await this.deleteLibraryEntryById(this.selectedEntry.Id)

    // Make sure to navigate away after deletion,
    // if any error happens user will remain on the same page and check error message.
    if (!deletionResult) return

    this.$router.push({ path: '/library' })
  }

  private async deleteAssetById() {
    if (this.referencePDFToDelete == null) return

    const assetGuidToDelete = this.referencePDFToDelete.assetGuid

    const deleteResult = await this.deleteLibraryReferenceAssetById(assetGuidToDelete)

    if (!deleteResult) return

    this.$refs.deleteAssetPromptYesNo.ClosePrompt()
    this.removeLibraryReferenceAssetByGuid(assetGuidToDelete)
    this.clearReferenceContextStatus(assetGuidToDelete)
    this.referencePDFToDelete = null
  }

  private async awaitLibraryEntryLoad(promiseLoadEntry: Promise<boolean>) {
    if (await promiseLoadEntry) {
      this.visibilityAlreadyPublic = this.libraryEntry.Visibility === LibraryObjectVisibility.Public

      this.selectedCategory = this.libraryEntry.Categories[0] != null ? this.libraryEntry.Categories[0] : null
      this.objectTags = this.libraryEntry.Tags.join(',')
    }

    if (this.libraryModelUID === -1) return

    await this.loadLibraryReferenceAssets({
      libraryModelId: this.libraryModelUID,
      limit: 999,
    })

    if (!this.libraryReferenceAssets || this.libraryReferenceAssets.length === 0) {
      this.referenceContextStatuses = {}
      this.referencePDFToDelete = null
      this.refPDFFileName = ''
      return
    }

    this.initializeReferenceContextStatuses()
    void this.loadReferenceContextStatuses()
  }

  private showDeleteEntryPrompt(item: any) {
    this.selectedEntry = item
    this.$refs.deleteEntryPromptYesNo.ShowPrompt()
  }

  private async onPublishCheckSuccess() {
    this.needPublishCheck = false
    this.saveChanges()
  }

  private async saveChanges() {
    if (this.needPublishCheck) {
      this.selectedEntry = this.libraryEntry
      this.$refs.publishEntryPromptYesNo.ShowPrompt()
      return
    }

    // Prepare library entry updates
    this.libraryEntry.Tags = this.objectTags.split(',').map((tag: string) => tag.trim())
    this.libraryEntry.Categories = this.selectedCategory != null ? [this.selectedCategory] : []

    // Run PDF upload and entry update in parallel
    this.isSubmittingPDF = this.referencePDFFile !== null

    const hasPDF = !!this.referencePDFFile
    const promises: [Promise<boolean>, Promise<boolean>] | [Promise<boolean>] = hasPDF
      ? [this.uploadPDFFile(), this.updateLibraryEntry(this.libraryEntry)]
      : [this.updateLibraryEntry(this.libraryEntry)]

    const results = await Promise.all(promises)
    this.isSubmittingPDF = false

    // Extract results - Promise.all maintains input order, not completion order
    const pdfSuccess = hasPDF ? results[0] : true
    const updateSuccess = hasPDF ? results[1] : results[0]

    // Reload entry if both operations were successful
    if (updateSuccess && pdfSuccess) {
      const promiseLoadEntry = this.loadLibraryEntry({
        Id: this.libraryEntry.Id,
      })
      await this.awaitLibraryEntryLoad(promiseLoadEntry)
    }
  }

  private triggerPDFUploadField() {
    if (this.isSubmittingPDF) return

    this.$refs.refPDFFileInput.$el.querySelector('input').click()
  }

  private onPDFFileChange(file: File) {
    if (file && file.name) {
      // Validate file size (max 50MB)
      if (file.size > this.maxPDFFileSize) {
        this.pdfFileSizeError = 'File size must be ' + TeamLibraryConst.ReferenceFileMaxSizeMB + 'MB or less'
        this.refPDFFileName = file.name
        this.referencePDFFile = null
        return
      }

      this.pdfFileSizeError = ''
      this.refPDFFileName = file.name
      this.referencePDFFile = file
    } else {
      this.clearReferencePDFSelection()
    }
  }

  private async uploadPDFFile(): Promise<boolean> {
    if (!this.referencePDFFile) return true

    const presignedResult = await this.presignedFile({
      libraryModelId: this.libraryModelUID,
      filename: this.referencePDFFile.name,
      mime: this.referencePDFFile.type,
      size: this.referencePDFFile.size,
    })

    if (!presignedResult) return false

    const uploadResult = await this.uploadReferenceFile({
      ...presignedResult,
      file: this.referencePDFFile,
    })

    if (!uploadResult || !uploadResult.data) return false

    const completeResult = await this.completeLibraryReferenceFileUpload({
      ...uploadResult.data,
      libraryModelId: this.libraryModelUID,
    })

    if (!completeResult) return false

    // Clear the file reference after successful upload
    this.clearReferencePDFSelection()

    return true
  }

  private removeReferencePDF() {
    this.clearReferencePDFSelection()
  }

  private removeReferenceAsset(asset: LibraryReferenceAsset) {
    this.referencePDFToDelete = asset
    this.$refs.deleteAssetPromptYesNo.ShowPrompt()
  }

  private async onPreviewReferenceAsset(asset: LibraryReferenceAsset) {
    if (!asset.referenceId) {
      return
    }

    const assetKey = this.previewAssetKey(asset)
    if (this.previewOpeningAssets[assetKey]) {
      return
    }

    this.$set(this.previewOpeningAssets, assetKey, true)

    try {
      this.previewReferenceId = asset.referenceId
      this.previewFilename = asset.originalFilename || 'Document preview'
      this.previewContentType = asset.contentType || ''
      this.previewTenantId = this.myTenantID > 0 ? this.myTenantID : TenantHelpers.InvalidTenantID
      this.previewDialogVisible = true
    } finally {
      this.$delete(this.previewOpeningAssets, assetKey)
    }
  }

  private onPreviewClose() {
    this.previewDialogVisible = false
  }

  @Watch('previewDialogVisible')
  private onPreviewDialogVisibleChanged(value: boolean) {
    if (!value) {
      this.previewReferenceId = 0
      this.previewFilename = 'Document preview'
      this.previewContentType = ''
      this.previewTenantId = TenantHelpers.InvalidTenantID
    }
  }

  private clearReferencePDFSelection() {
    this.referencePDFFile = null
    this.refPDFFileName = ''
    this.pdfFileSizeError = ''
  }

  private checkAboutToPublish(option: LibraryObjectVisibility) {
    const isPublicSelected = option === LibraryObjectVisibility.Public

    if (!this.visibilityAlreadyPublic) {
      this.needPublishCheck = isPublicSelected
    } else {
      this.needPublishCheck = !isPublicSelected
    }

    if (isPublicSelected && this.selectedCategory != null && !this.libraryPublicCategoriesIDs.includes(this.selectedCategory)) {
      // If entry is switching to Public but selected category is not public, clear selection
      this.selectedCategory = null
    } else if (!isPublicSelected && this.selectedCategory != null && this.libraryPublicCategoriesIDs.includes(this.selectedCategory)) {
      // If entry is switching away from Public, and selected category is public, clear selection
      this.selectedCategory = null
    }
  }

  private async onThumbnailUpload(thumbnailFile: File) {
    const req: UploadThumbnailRequest = {
      Id: this.libraryEntry.Id.toString(),
      TenantId: this.myTenantID,
      Thumbnail: thumbnailFile,
      IsFirstThumbnail: this.libraryEntry.ThumbnailUrl.includes('placeholder'),
    }
    this.isUploadingThumbnail = true
    if (await this.uploadLibraryEntryThumbnail(req)) {
      const promiseLoadEntry = this.loadLibraryEntry({
        Id: this.libraryEntry.Id,
      })
      this.awaitLibraryEntryLoad(promiseLoadEntry)
    }
    this.isUploadingThumbnail = false
    this.showUploadModel = false
  }

  private checkPermissions() {
    this.canEdit = false
    this.canDelete = false
    this.canGenerateJig = false
    this.isJigSpaceStaff = false
    const tenant = TenantHelpers.GetTenantByIndex(this.myTenantIndex, this.myTenants)
    if (tenant !== null && tenant !== undefined) {
      this.isJigSpaceStaff = TenantHelpers.IsTenantJigSpaceStaff(tenant)
      const tenantTokens = this.$auth0.tenants
      const tenantToken = TenantHelpers.GetTenantTokenByTenantID(tenantTokens, tenant.ID)
      if (tenantToken !== undefined) {
        this.canEdit = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Edit)
        this.canDelete = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermLibrary, PermissionActions.Delete)
        this.canGenerateJig = Permissions.TokenHasPermissionAction(tenantToken, Permissions.PermJigs, PermissionActions.Create)
      }
    }
  }

  private onUploadClicked(payload: any) {
    this.showUploadModel = true
  }

  private openGenerateJig() {
    ;(this.$refs.generateJigModal as InstanceType<typeof GenerateJigModal>).show()
  }

  private onCancelUploadClick() {
    this.showUploadModel = false
  }

  private goBack() {
    if ((window && window.history.length > 1) || (history && history.length > 1)) {
      this.$router.back()
    } else {
      this.$router.push('/library')
    }
  }

  private async triggerManageCategoriesPrompt() {
    this.showCategoriesModel = true
    this.isCategoriesUsageLoading = true
    await this.loadLibraryCategoriesUsage(this.myTenantID)
    this.isCategoriesUsageLoading = false
  }

  private onCategoriesCancelClicked() {
    this.showCategoriesModel = false
    this.isCategoriesUsageLoading = false
  }

  private onCategoryChange(categoryId: number | null) {
    if (!this.isJigSpaceStaff || categoryId == null) return

    if (this.libraryPublicCategoriesIDs.includes(categoryId)) {
      this.libraryEntry.Visibility = LibraryObjectVisibility.Public
    } else {
      this.libraryEntry.Visibility = LibraryObjectVisibility.Tenant
    }

    this.checkAboutToPublish(this.libraryEntry.Visibility)
  }
}
